module.exports = __webpack_public_path__ + "static/assets/4d0adfe4fa9f620d0f0eeed63d7dcc9d.svg";